import {useForm} from "react-hook-form-old";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";

import useSystem from "../../hooks/useSystem";
import useDelivery from "../../hooks/useDelivery";

import HopCard from "../Shop/HopCard";

import Freihopfen from "../Freihopfen/Freihopfen";
import EstimatedQuantity from "../Freihopfen/EstimatedQuantity";
import PoolhopfenMenge from "./PoolhopfenMenge";
import Overdelivery from "../Freihopfen/Overdelivery";

import Kaufpreisberechnung from "./Kaufpreisberechnung";
import Zusatzvereinbarungen from "../Angebote/Zusatzvereinbarungen";

import {saveOffer} from "../../actions/formActions";
import {getHopType} from "../../lib/getHopType";

export default function Vertragsangebot(props) {
  const angebot = props;
  const system = useSystem();
  const history = useHistory();
  const dispatch = useDispatch();
  const {form} = useSelector((state) => state);

  const lieferung = useDelivery(angebot.Sorte);
  const initialValue = form.data === undefined ? [] : form.data;

  const {watch, register, handleSubmit, errors, control, setValue} = useForm({
    mode: "onBlur",
    defaultValues: {
      freihopfen: initialValue.freihopfen,
      poolamount: initialValue.poolamount,
      estimate: initialValue.estimate,
      partie: initialValue.partie,
      überlieferung: initialValue.überlieferung,
      weight: initialValue.weight,
    },
  });

  const onSubmit = (data) => {
    const formValues = {
      data: data,
      angebot: angebot,
    };
    dispatch(saveOffer(formValues));
    history.push("/abschluss");
  };

  const freihopfen = watch().freihopfen;
  const type = getHopType(angebot);
  const art = "Pool-Hopfen";

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="md:flex md:items-center md:justify-between">
        <div className="flex-1 min-w-0">
          <h1 className="border-b border-primary text-2xl uppercase font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
            Vertragsangebot
          </h1>
          <br/>
          <ul>
            <HopCard
              cropYear={system.cropYear}
              angebot={angebot}
              button={false}
            />
          </ul>
          <br/>

          <Freihopfen
            angebot={angebot}
            register={register}
            lieferung={lieferung}
            art={art}
            setValue={setValue}
          />

          {watch().freihopfen === "0" && <EstimatedQuantity register={register} contractType={art}/>}
          {watch().freihopfen === "1" && (
            <PoolhopfenMenge
              register={register}
              watch={watch}
              errors={errors}
              art={art}
              type={type}
              lieferung={lieferung}
              control={control}
            />
          )}
          {watch().freihopfen === "2" && <Overdelivery delivery={lieferung} contractType={art}/>}
        </div>
      </div>
      <br/>
      <Kaufpreisberechnung
        title={"Kaufpreisberechnung"}
        angebot={angebot}
        type={type}
      />
      <Zusatzvereinbarungen title="Zusatzvereinbarungen" angebot={angebot}/>
      <div className="pt-5">
        <div className="flex justify-end">
          <a
            href="/angebote"
            className="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary"
          >
            Zurück
          </a>
          {freihopfen === "2" && lieferung === 0 ? (
            ""
          ) : (
            <button
              type="submit"
              className="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-primary hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary"
            >
              Ihr Vertragsangebot prüfen
            </button>
          )}
        </div>
      </div>
    </form>
  );
}
